import React, { useState } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { Iconfont } from "../../../../../../../components/icon/iconfont";
import { IMAGE_GEEKO_LTD } from "../../../../../../../../constants";
import { getLowerPrice } from "../../../../../../../../utils/product";
import { unitPrice } from "../../../../../../../../utils/product";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

const DownloadApp = props =>{
    const { selectedProduct } = props;
    const lower = getLowerPrice(selectedProduct);
    const global = useSelector(state=>state.global);
    const { config } = global;

    return <div className={classes.DownloadApp}>
        <div className={classes.Hd}>
            <div>
                <img src={`${IMAGE_GEEKO_LTD}/large/${selectedProduct?.pcMainImage}`} alt="App Exclusive" />
            </div>

            <div>
                <p className={classes.Price}>{unitPrice(lower) || '-'}</p>
                <p className={classes.Message}>{selectedProduct?.appExclusiveZone?.message}</p>
            </div>
        </div>

        {
            config?.app?.qrcode && <div className={classes.Bd}>
                <img src={config?.app?.qrcode} alt="DownLoadCode" />
            </div>
        }

        <div className={classes.Fd}>
            <span><FormattedMessage id="simply_special_price" defaultMessage="Simply scan the QR code to install and get ready with the SPECIAL PRICE!" /></span>
        </div>
    </div>
}

const ProductAppExclusive = props =>{
    useStyles(classes);
    const { selectedProduct } = props;
    const [show,setShow] = useState(false);

    return <React.Fragment>
        {
            selectedProduct?.appExclusiveZone?.enable && <div className={classes.ProductAppExclusive}>
                <div className={classes.Container}>
                    <div className={classes.Left}>
                        <Iconfont>&#xe704;</Iconfont>
                        <span>{selectedProduct?.appExclusiveZone?.message}</span>
                    </div>
                    <div 
                        className={classes.Right} 
                        onMouseOver={()=>{setShow(true)}}
                        onMouseOut={()=>{setShow(false)}}
                    >
                        <span><FormattedMessage id="download_app" defaultMessage="Download APP" /> {'>'}</span>
                    </div>
                </div>

                {
                    show && <DownloadApp {...props} />
                }
            </div>
        }
    </React.Fragment>
    
}

export default ProductAppExclusive;